import React from "react";
import PropTypes from "prop-types";
import Datetime from "react-datetime";
import DateTimePicker from 'react-datetime-picker';
import moment from "moment"
import { db, firebase } from "firebase/fbConfig.js"

import axios from 'axios'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import Icon from "@material-ui/core/Icon";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomDropdown from 'components/CustomDropdown/CustomDropdown.jsx';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import styles from "assets/jss/material-dashboard-pro-react/components/profileFormStyle.jsx";

import { addNewUser } from "store/actions/profileActions.jsx"

// Assets
import precincts from "variables/precincts.jsx"
import ExploreAssignUser from "../../views/Explore/ExploreAssignUser";

class Form extends React.Component {

    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            ...this.state,
            userDataLoaded: false
        };
    }

    handleDOBChange = (dob) => {
        console.log(dob._d)
        if (dob) {
            this.setState(() => ({ dob: dob._d }))
        }
    }


    // componentDidMount = () => {
    //   var inputElement = document.getElementById('mainPhone');
    //   inputElement.removeEventListener('keydown', this.enforceFormat);
    //   inputElement.removeEventListener('keyup', this.formatToPhone);
    //   var inputElement2 = document.getElementById('mainPhone');
    //   inputElement2.removeEventListener('keydown', this.enforceFormat);
    //   inputElement2.removeEventListener('keyup', this.formatToPhone);

    // }

    // componentWillUnmount = () => {
    //   var inputElement = document.getElementById('mainPhone');
    //   inputElement.removeEventListener('keydown', this.enforceFormat);
    //   inputElement.removeEventListener('keyup', this.formatToPhone);
    //   var inputElement2 = document.getElementById('mainPhone');
    //   inputElement2.removeEventListener('keydown', this.enforceFormat);
    //   inputElement2.removeEventListener('keyup', this.formatToPhone);

    // }

    //Phone number code modified from
    // https://stackoverflow.com/questions/30058927/format-a-phone-number-as-a-user-types-using-pure-javascript 
    isNumericInput = (event) => {
        const key = event.keyCode;
        return ((key >= 48 && key <= 57) || // Allow number line
            (key >= 96 && key <= 105) // Allow number pad
        );
    };

    isModifierKey = (event) => {
        const key = event.keyCode;
        return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
            (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
            (key > 36 && key < 41) || // Allow left, up, right, down
            (
                // Allow Ctrl/Command + A,C,V,X,Z
                (event.ctrlKey === true || event.metaKey === true) &&
                (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
            )
    };

    enforceFormat = (event) => {
        // Input must be of a valid number format or a modifier key, and not longer than ten digits
        if (!this.isNumericInput(event) && !this.isModifierKey(event)) {
            event.preventDefault();
        }
    };

    formatToPhone = (event) => {
        if (this.isModifierKey(event)) {
            return;
        }

        // I am lazy and don't like to type things more than once
        const target = event.target;
        const input = event.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only    
        const zip = input.substring(0, 3);
        const middle = input.substring(3, 6);
        const last = input.substring(6, 10);

        let targetValue
        if (input.length > 6) { targetValue = `(${zip}) ${middle} - ${last}`; }
        else if (input.length > 3) { targetValue = `(${zip}) ${middle}`; }
        else if (input.length > 0) { targetValue = `(${zip}`; }
        target.value = targetValue
        this.setState({
            phone: targetValue
        })
    };

    capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    onChange = dob => this.setState({ dob })

    handleChange = (e) => {
        let value = e.target.value
        if (e.target.id === "firstName" || e.target.id === "lastName") {
            value = value.charAt(0).toUpperCase() + value.slice(1)
        }
        console.log(value)
        this.setState({
            [e.target.id]: value
        })
    }


    handleSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        addNewUser(this.state.user, this.state.vendorData.id, this.props.type, this.state.vendorData.name)
    }

    handleToggle(value) {
        const { groups } = this.state;
        const currentIndex = groups.indexOf(value);
        const newGroups = [...groups];

        if (currentIndex === -1) {
            newGroups.push(value);
        } else {
            newGroups.splice(currentIndex, 1);
        }

        this.setState({
            groups: newGroups
        });
    }


    handleToggleTerms(value) {
        const { termGroups } = this.state;
        const currentIndex = termGroups.indexOf(value);
        const newTermGroups = [...termGroups];

        if (currentIndex === -1) {
            newTermGroups.push(value);
        } else {
            newTermGroups.splice(currentIndex, 1);
        }

        this.setState({
            termGroups: newTermGroups
        });
    }

    loadUsersData = (id) => {
        let data = db.collection("TEST-users").where('name', '>', '')
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.firstName + " " + docData.lastName,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    userData: data,
                    userDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadVendorsData = (type, id) => {
        //console.log("loading vendor data")
        let data = db.collection(`TEST-${type}`).doc(id)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    vendorData: docObj,
                    vendorDataLoaded: true
                })
            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

      assignUser = (userID, firstName, lastName, email, cell) => {
    this.setState({
        user: {
            name: firstName + " " + lastName,
            id: userID,
            email: email, 
            cell
        }
    });
    // this.props.onAssignUser(userID, firstName, lastName, email)
}


    render() {
        const { classes, type, id } = this.props;

        const counties = ['Clark', 'Cowlitz', 'Lewis', 'Pacific', 'Wahkiakum', 'Skamania', 'Klickitat', 'Other']

        const vendorUserTypes = ['', 'Employee', 'Driver']
        const shipperUserTypes = ['', 'Employee']
        const trailerType = ['', 'Dry Van', 'Reefer', 'Flat Bed']

        if (!this.state.userDataLoaded) {
            this.loadUsersData();
            this.loadVendorsData(type, id);
        }

        console.log(this.state)
        return (
            <div className={classes.formContainer}>
                {/* <form onSubmit={this.handleSubmit} */}
                {
                    this.state.userDataLoaded ?

                        <form onSubmit={this.handleSubmit}
                        >
                            <GridContainer justify="center">
                                <GridItem xs={11}>
                                    {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error</h5> : null}
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            <ExploreAssignUser onAssignUser={this.assignUser} />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                            <Button
                                type="submit"
                                color="primary"
                                style={{
                                    marginLeft: "10px",
                                    marginBottom: "10px"
                                }}
                            >
                                Save Changes
            </Button>
                        </form>
                        :
                        null

                }
            </div>
        );
    }
}

Form.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Form);



// WEBPACK FOOTER //
// ./src/components/Forms/AssociatePersonForm.jsx